import {
  identifierRegex,
  parseFormData,
  Property,
  Report,
  ReportDefinition
} from '@cumu/shared';
import { allFormData } from './forms/utilities';

const definitionsMap = new Map<HTMLFormElement, ReportDefinition>();
const propertiesMap = new Map<HTMLFormElement, Property[]>();

export function parseReportDefinition(form: HTMLFormElement): {
  definition: ReportDefinition;
  properties: Property[];
} {
  let definition = definitionsMap.get(form);
  let properties = propertiesMap.get(form);
  if (definition && properties) {
    // console.log('cached');
  } else {
    // console.log('not cached');
    definition = parseFormData<Report>(allFormData(form)).definition;
    definition.parameters ??= [];
    definition.parameters.forEach((p, i) => {
      p.name = p.name.toUpperCase();
      if (!identifierRegex.test(p.name)) {
        p.name = `$PARAMETER_${i}`;
      }
    });
    properties = Array.from(
      form.querySelectorAll<HTMLInputElement>('[data-property^="{"]')
    )
      .map(el => JSON.parse(el.dataset.property!))
      .filter(
        (x, i, a) => a.findIndex(y => y.property_id === x.property_id) === i
      );
    definitionsMap.set(form, definition);
    propertiesMap.set(form, properties);
    Promise.resolve().then(() => {
      definitionsMap.delete(form);
      propertiesMap.delete(form);
    });
  }
  return { definition, properties };
}
